export function findCycle(nodes = [], edges = []) {
  const adjacency = new Map(nodes.map((node) => [node.id, []]))
  edges.forEach((edge) => {
    if (adjacency.has(edge?.from) && adjacency.has(edge?.to)) adjacency.get(edge.from).push(edge.to)
  })
  const active = new Set()
  const visited = new Set()
  function visit(id, path) {
    if (active.has(id)) return [...path.slice(path.indexOf(id)), id]
    if (visited.has(id)) return null
    active.add(id)
    for (const next of adjacency.get(id) || []) {
      const cycle = visit(next, [...path, id])
      if (cycle) return cycle
    }
    active.delete(id)
    visited.add(id)
    return null
  }
  for (const node of nodes) {
    const cycle = visit(node.id, [])
    if (cycle) return cycle
  }
  return null
}

export function validateEdge({ nodes = [], edges = [], edge }) {
  if (!edge?.from || !edge?.to) return { ok: false, code: 'edge.invalid', message: '连线端点无效' }
  if (edge.from === edge.to) return { ok: false, code: 'edge.self', message: '不能连接节点自身' }
  if (!nodes.some((node) => node.id === edge.from) || !nodes.some((node) => node.id === edge.to)) return { ok: false, code: 'edge.node-missing', message: '连线节点不存在' }
  if (edges.some((item) => item.from === edge.from && item.to === edge.to && item.fromPort === edge.fromPort && item.toPort === edge.toPort)) return { ok: false, code: 'edge.duplicate', message: '连线已经存在' }
  if (findCycle(nodes, [...edges, edge])) return { ok: false, code: 'edge.cycle', message: '该连线会形成循环' }
  return { ok: true }
}
